module.exports = __webpack_public_path__ + "assets/img/521f-gb.svg";